// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'End the day for multiple branches'"></sub-header>

    <div ng-if="\$ctrl.loading">
      <h2 class="misc-transaction__error-title">Loading...</h2>
    </div>

    <div ng-if="!\$ctrl.loading">
      <table class="administration-branches branches-list table table--generate-row-ids table--last-column-to-right">
        <thead>
        <tr>
          <th></th>
          <th>Organization</th>
          <th>Branch name</th>
          <th>Branch code</th>
          <th>System date</th>
          <th>Posting date</th>
          <th>Working day status</th>
          <th>Health check status</th>
          <th>Run in batch</th>
          <th>Latest EOD status</th>
          <th command-access="EndDay">Actions</th>
        </tr>
        </thead>
        <tbody class="tbody">
        <tr ng-repeat="branch in \$ctrl.branches">
          <td class="branches-list__number-column"></td>
          <td>{{ branch.organization.name }}</td>
          <td>{{ branch.name }}</td>
          <td>{{ branch.code }}</td>
          <td>{{ branch.systemDate }}</td>
          <td>{{ branch.postingDate }}</td>
          <td ng-class="{'active' : branch.status.code === 'STARTED',
                       'pending' : !['STARTED', 'COUNTER_CLOSED'].includes(branch.status.code),
                       'closed' : branch.status.code === 'COUNTER_CLOSED'}">
            {{ branch.status.label }}
          </td>
          <td ng-class="{'active' : branch.healthCheckStatus === 'Passed',
                       'pending' : ['Disabled', 'Loading'].includes(branch.healthCheckStatus),
                       'closed' : branch.healthCheckStatus === 'Failed'}">
            {{ branch.healthCheckStatus }}
          </td>
          <td>
            <input type="checkbox"
                   ng-model="branch.selected"
                   ng-if="\$ctrl.canEOD(branch)"
                   ng-click="\$ctrl.onBranchCheckboxClicked(branch.selected)">
          </td>
          <td ng-class="{ 'pending': \$ctrl.branchIdJobStatusMap[branch.id] === 'PENDING',
                        'error': \$ctrl.branchIdJobStatusMap[branch.id] === 'FAILED',
                        'neutral': !['PENDING', 'FAILED'].includes(\$ctrl.branchIdJobStatusMap[branch.id])}">
            {{ \$ctrl.branchIdJobStatusMap[branch.id] }}
          </td>
          <td command-access="EndDay" class="branches-list__open-link-column">
            <div class="summary-actions">
              <button class="btn open-link"
                      command-access="EndDay"
                      type="button"
                      ng-click="\$ctrl.onIndividualEODClicked(branch)"
                      ng-class="{ 'invisible': !\$ctrl.canEOD(branch)}">
                Individual EOD
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="branches-list__number-column"></td>
          <td colspan="7">
            Process all in batch:
          </td>
          <td>
            <input type="checkbox"
                   ng-model="\$ctrl.selectAll"
                   ng-click="\$ctrl.onSelectAllChange(\$ctrl.selectAll)"
                   ng-disabled="!\$ctrl.isSelectAllEnabled()">
            <help
              title="Selects all branches that are valid for performing EOD. Inactive when there is no branch that can run EOD."></help>
          </td>
          <td></td>
          <td command-access="EndDay"></td>
        </tr>
        </tbody>
      </table>

      <div class="summary-actions">
        <button class="btn btn-warning"
                type="button"
                ng-click="\$ctrl.onExitClicked()">Exit
        </button>
        <button class="btn btn-primary"
                type="button"
                ng-disabled="!\$ctrl.isStartBatchEnabled()"
                ng-click="\$ctrl.onStartBatchClicked()">Start batch
        </button>
      </div>
    </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/batch-end-the-day/batch-end-the-day.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;